module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/icon_parking-e8692cc399969b34b82fa6a5ec5b0ddd.svg";